"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { FilterHorizontalIcon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";

type Props = {
  className?: string;
  color?: string;
};

const FilterIcon: FC<Props> = ({ className, color = "currentColor" }) => (
  <HugeiconsIcon
    icon={FilterHorizontalIcon}
    className={className}
    color={color}
    strokeWidth={1.5}
  />
);

export default FilterIcon;
